import { styled } from '@clickcease/cc-client-components-lib'

export const NotificationsSectionStyled = styled('div', {
  width: 'calc(100% -  40px)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '$10',
  background: '#ffffff',
  boxShadow: '0px 0px 30px rgba(102, 102, 102, 0.05)',
  minHeight: '195px',
  borderRadius: '12px',
})

export const DescriptionRow1 = styled('div', {
  marginTop: '$10',
  fontWeight: '$rb',
  fontSize: '$md',
  color: '$mainTextColor',
})

export const DescriptionRow2 = styled('div', {
  marginTop: '$2',
  fontWeight: '$l',
  fontSize: '$md',
  color: '$mainTextColor',
})

export const BoxesWrapper = styled('div', {
  display: 'flex',
  margin: '20px 0px 32px',
  ['> div:first-child']: {
    marginRight: '20px',
  },
})

export const RealTimeOptions = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '30px',
})

export const SwitchOptionsWrapper = styled('div', {
  display: 'flex',
  marginBottom: '20px',
  lineHeight: '14px',
})

export const SwitchOptionLabel = styled('div', {
  color: '$mainTextColor',
  fontWeight: '$rb',
  fontSize: '$md',
  marginLeft: '8px',
})

export const RealTimeCheckboxWrapper = styled('div', {
  marginBottom: '18px',
})

export const RealTimeDescription = styled('div', {
  marginBottom: '21px',
})
